import { render, staticRenderFns } from "./PQRInfo.vue?vue&type=template&id=dc48189e"
import script from "./PQRInfo.vue?vue&type=script&lang=js"
export * from "./PQRInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports